import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import MergeUsersForm from './components/merge-users-form';

export default function Users() {
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>Users</CardTitle>
          <CardDescription>Manage your application users.</CardDescription>
        </CardHeader>

        <MergeUsersForm />
      </Card>
    </>
  );
}
